import { Component, OnInit } from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router';
import {HttpClient,HttpParams,HttpEventType,HttpResponse,HttpRequest,HttpHeaders} from '@angular/common/http';
import { environment as configs } from 'src/environments/environment';
@Component({
  selector: 'app-integrate-csc',
  templateUrl: './integrate-csc.component.html',
  styleUrls: ['./integrate-csc.component.css']
})
export class IntegrateCscComponent implements OnInit {
statusLoad = false;
   host=configs['ApiHost'];
  constructor(private actRoute:ActivatedRoute,private httpClient:HttpClient,private router:Router) { }

  ngOnInit() {
//     this.actRoute.params.subscribe(resp=>{
//       // console.log(resp.id) this.host+'
     
//       this.httpClient.get('http://20.244.5.14:3000/integrate/csc/'+resp.id,{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).subscribe(resp=>{
//         if(resp['status']==true){
// this.statusLoad = true;

//           let user={'role':resp['role'],
//                     'username':resp['username'],
//                     'branch':resp['branch'],
//           }
//           localStorage.setItem('auth-token',resp['token']);
//           localStorage.setItem('user',JSON.stringify(user));
//           // if(resp['pageUrl']=='register')
//           // {
//           //   this.router.navigate(['/worker/register']);
//           // }
//           // if(resp['pageUrl']=='scheme')
//           // {
//           //   this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:60}})
//           // }
         

//         }else{
// this.statusLoad = false;

//           this.router.navigate(['login'])
//         }

//       })

//     })
  }
  workerRedirect() {
    this.router.navigate(['/worker/register']);
  }
  bicyclePartOneRedirect() {
    this.router.navigate(['/worker/scheme-view-forms'],{queryParams:{id:60}})
  }  
}
